import { atom, selector, selectorFamily } from 'recoil';

export const wallet = atom({
	key: 'wallet',
	default: null,
});

export const balnce = atom({
	key: 'balance',
	default: 0,
});

export const membership_rank = atom({
	key: 'membership_rank',
	default: 'N/A',
});

export const isLoggedAccount = atom({
	key: 'isLoggedAccount',
	default: false,
});

export const WalletConnectModalOpen = atom({
	key: 'WalletConnectModalOpen',
	default: false,
});

export const InnerModalOpen = atom({
	key: 'InnerModalOpen',
	default: false,
});

export const userConnected = atom({
	key: 'userConnected',
	default: false,
});

export const BoxDetailModalOpen = atom({
	key: 'BoxDetailModalOpen',
	default: false,
});

export const PFPUnboxingData = atom({
	key: 'PFPUnboxingData',
	default: null,
});

export const Login = atom({
	key: 'Login',
	default: false,
});

export const isSessionSaved = atom({
	key: 'isSessionSaved',
	default: false,
});
